import styled from "styled-components"

export const GreenRoomControlsRoot = styled.div`
    width: 350px;
    height: 100px;
    display: flex;
    padding: 20px;
`
